/// <reference path="./index.d.ts" />
import * as React from 'react';
import { Balloon } from '@alifd/next';
import './ppe.scss';

interface propTypes extends SelfOperatedInfo {
    i18n: object
    companyName: string
}


export default function PPE ( { i18n,labels,services,urlForPc,titleText }: propTypes ) {
    return (
        <div id="seller-self-operated-card" className="ppe">
            <div className="alibaba-shop-card">
                <div className="offical-name-and-photo">
                    <a className="offical-name" target="_blank" href={urlForPc} data-aui="company-name" data-domdot="id:3317">
                        {titleText}
                    </a>
                    <div className="tag-item">
                        {labels.map( item => <span>{item}</span> )}
                    </div>
                </div>
                <div className="we-promise">
                    {i18n['companyCardIntegrated.self.promise']}
                </div>
                <div className="promise-list">
                    <ul className="promise-list-ul">
                        {services.map( ( item,index ) => <Balloon
                            trigger={
                                <li key={index} className="promise-list-li">
                                    <img src={item.icon} />
                                    <span>{item.service}</span>
                                </li>
                            }
                            key={index}
                            closable={false}
                            align="bl"
                            alignEdge
                            className="promise-list-li-balloon"
                            style={{
                                maxWidth: '232px',
                                background: '#FAFAFA',
                                color: '#333',
                            }}
                        >
                            {item.tip}
                        </Balloon> )}
                    </ul>
                </div>
            </div>
        </div>
    )
}
